export default __webpack_public_path__ + "static/media/logo.172b8921.svg";